<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/constantia')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/south-africa/constantia/restless-river')">Restless River
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/constantia')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Fiume Inquieto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Con i vini pregiati che aumentano di valore, alcune annate e produttori sono molto richiesti. Buon vino
                        gli investitori hanno goduto di un enorme rendimento medio del 24% sul loro investimento nel 2018, il 18% in più rispetto a
                        auto d'epoca e il 23% in più rispetto ai diamanti. Il prodotto è scarso per i grandi battitori (il gelo di
                        2016 ha quasi spazzato via le offerte della Borgogna), così lo sono alcuni cosiddetti "vini del nuovo mondo".
                        godendo il loro tempo per brillare. Come il più antico del nuovo, è naturale che i nostri pensieri
                        rivolgersi al Sud Africa.
                    </div>

                    <div class="howto-title2">Lo chiami vecchio?</div>
                    <div class="howto-text">
                        Una delle stelle nascenti del Sud Africa è Restless River. Proclamandolo con orgoglio uno dei vigneti più "antichi" (piantati, ahem, 1999) in Sud Africa, Restless River ha iniziato la sua vita
                        come avventura per hobby per l'animatore Craig Wessels con sua moglie Anne. Ha acquistato la cantina nel 2004,
                        ha realizzato il suo primo Cabernet non commerciale nel 2005 e questo è stato più o meno quello per i successivi sette
                        o così anni. Ma nel 2015 è stato lanciato Restless River Main Road e Dignity Cabernet Sauvignon
                        sul mercato ignaro, seguito dal brillante Ave Maria Chardonnay in stile borgognone.
                        Rese basse (solo 15.000 bottiglie complessive dai loro vigneti di 7 ettari), terreno buono e
                        l'agricoltura sostenibile ha fatto guadagnare a Restless un seguito di culto tra enologi esperti, critici e
                        allo stesso modo gli investitori. Restless ha attualmente due annate di Pinot Noir in botte che sono
                        test (vigne piantate nel 2015, le cuvée di prova sono 2016 e 2017), che Wessel spera di aggiungere alla sua
                        gamma principale, tutto bene.
                    </div>

                    <div class="howto-title2">Sudafrica contro il resto del mondo</div>
                    <div class="howto-text">
                        I vini sudafricani, in generale, devono ancora realisticamente offrire una vera concorrenza nel
                        Mercato dominato dall'Europa. Tuttavia, chissà se sarà ancora così tra dieci o quindici
                        anni? Per chi cerca un vino pregiato investibile alternativo che abbia prezzi bassi e
                        buon potenziale di invecchiamento, Restless River è sicuramente un vino da tenere d'occhio.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Ruheloser Fluss</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Da erlesene Weine immer wertvoller werden, sind bestimmte Jahrgänge und Produzenten dringend gefragt. Guter Wein
                        Anleger konnten sich im Jahr 2018 über eine enorme durchschnittliche Kapitalrendite von 24 % freuen, 18 % mehr als
                        Oldtimer und 23 % höher als Diamanten. Das Produkt ist für die Schwergewichte knapp (der Frost von
                        2016 hat das Angebot Burgunds nahezu ausgelöscht), so auch bestimmte sogenannte „Neue-Welt-Weine“.
                        Sie genießen ihre Zeit, um zu glänzen. Als Ältestes des Neuen ist es nur natürlich, dass unsere Gedanken
                        Wenden Sie sich an Südafrika.
                    </div>

                    <div class="howto-title2">Das nennst du alt?</div>
                    <div class="howto-text">
                        Einer der aufstrebenden Stars Südafrikas ist Restless River. Restless River verkündete stolz, es sei eines der „ältesten“ (ähm, 1999 gepflanzten) Weinberge in Südafrika und begann sein Leben
                        als Hobby für den Trickfilmzeichner Craig Wessels und seine Frau Anne. Er kaufte das Weingut im Jahr 2004,
                        stellte seinen ersten nichtkommerziellen Cabernet im Jahr 2005 her und das war mehr oder weniger das für die nächsten sieben
                        oder so Jahre. Aber im Jahr 2015 wurde Restless River Main Road und Dignity Cabernet Sauvignon auf den Markt gebracht
                        auf den ahnungslosen Markt, gefolgt vom brillanten Ave Maria Chardonnay im burgundischen Stil.
                        Geringe Erträge (insgesamt nur 15.000 Flaschen aus ihren 7 Hektar großen Weinbergen), guter Boden und
                        Nachhaltige Landwirtschaft hat Restless einen Kultstatus unter versierten Onenologen, Kritikern und anderen eingebracht
                        Anleger gleichermaßen. Restless hat derzeit zwei Jahrgänge Pinot Noir im Fass
                        Tests (Reben gepflanzt im Jahr 2015, Testcuvees stammen aus den Jahren 2016 und 2017), die Wessel hoffentlich zu seinen hinzufügen wird
                        Kernbereich, alles in Ordnung.
                    </div>

                    <div class="howto-title2">Südafrika gegen den Rest der Welt</div>
                    <div class="howto-text">
                        Südafrikanische Weine müssen im Allgemeinen realistischerweise immer noch keine echte Konkurrenz bieten
                        Europa dominierter Markt. Wer weiß allerdings, ob das auch in zehn oder 15 Jahren noch der Fall sein wird
                        Jahre Zeit? Für diejenigen, die nach einem alternativ investierbaren guten Wein suchen, der preisgünstig ist
                        Aufgrund seines guten Alterungspotenzials ist Restless River auf jeden Fall ein Wein, den man im Auge behalten sollte.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Rivière agitée</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avec la montée en valeur des vins fins, certains millésimes et producteurs sont en demande urgente. Bon vin
                        les investisseurs ont bénéficié d'un rendement moyen massif de 24% sur leur investissement en 2018, 18% de plus que
                        voitures anciennes et 23% de plus que les diamants. Le produit est rare pour les gros frappeurs (le gel de
                        2016 a pratiquement anéanti l'offre bourguignonne), ainsi certains vins dits « du nouveau monde » sont
                        profiter de leur temps pour briller. En tant que plus ancien du nouveau, il est naturel que nos pensées
                        tourner vers l'Afrique du Sud.
                    </div>

                    <div class="howto-title2">Vous appelez ça vieux?</div>
                    <div class="howto-text">
                        L'une des étoiles montantes de l'Afrique du Sud est Restless River. Proclamant fièrement qu'il s'agit de l'un des vignobles "les plus anciens" (plantés en, ahem, 1999) d'Afrique du Sud, Restless River a commencé sa vie
                        comme passe-temps pour l'animateur Craig Wessels avec sa femme Anne. Il rachète le domaine en 2004,
                        a fait son premier cabernet non commercial en 2005 et ce fut à peu près cela pour les sept suivants
                        ou alors des années. Mais en 2015 Restless River Main Road et Dignity Cabernet Sauvignon ont été lancés
                        sur le marché sans méfiance, suivi du brillant Ave Maria Chardonnay de style bourguignon.
                        De faibles rendements (seulement 15 000 bouteilles au total de leurs vignobles de 7 hectares), un bon sol et
                        l'agriculture durable ont valu à Restless un culte parmi les onologues avisés, les critiques et
                        investisseurs. Restless a actuellement deux millésimes de Pinot Noir en fût qu'ils sont
                        tests (vignes plantées en 2015, les cuvées test sont 2016 et 2017), que Wessel espère ajouter à son
                        cœur de gamme, tout va bien.
                    </div>

                    <div class="howto-title2">L'Afrique du Sud contre le reste du monde</div>
                    <div class="howto-text">
                        Les vins sud-africains, en général, doivent encore offrir de manière réaliste une réelle concurrence dans le
                        Marché dominé par l'Europe. Cependant, qui sait si ce sera encore le cas dans 10 ou 15
                        ans de temps? Pour ceux qui recherchent un bon vin alternatif à investir à bas prix et
                        bon potentiel de garde, Restless River est assurément un vin à surveiller.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Restless River</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        With fine wines rising in value, certain vintages and producers are in urgent demand. Fine wine
                        investors enjoyed a massive 24% average return on their investment in 2018, 18% higher than
                        vintage cars and 23% higher than diamonds. Product is scarce for the heavy hitters (the frost of
                        2016 all but wiped out Burgundy’s offerings), thus certain so-called “new world wines” are
                        enjoying their time to shine. As the oldest of the new, it is only natural that our thoughts
                        turn to South Africa.
                    </div>

                    <div class="howto-title2">You call that old?</div>
                    <div class="howto-text">
                        One of the rising stars of South Africa is Restless River. Proudly proclaiming it to be one of the “oldest” (planted in, ahem, 1999) vineyards in South Africa, Restless River started out life
                        as a hobby venture for animator Craig Wessels with his wife Anne. He bought the winery in 2004,
                        made his first non-commercial Cabernet in 2005 and that was more or less that for the next seven
                        or so years. But in 2015 Restless River Main Road and Dignity Cabernet Sauvignon was launched
                        onto the unsuspecting market, followed by the brilliant, Burgundian-style Ave Maria Chardonnay.
                        Low yields (just 15,000 bottles overall from their 7-hectare vineyards), good soil and
                        sustainable farming have earned Restless a cult following among savvy onenologes, critics and
                        investors alike. Restless currently has two vintages of Pinot Noir in barrel that they are
                        testing (vines planted in 2015, test cuvees are 2016 and 2017), which Wessel hopes to add to his
                        core range, all being well.
                    </div>

                    <div class="howto-title2">South Africa vs. the Rest of the World</div>
                    <div class="howto-text">
                        South African wines, in general, have still to realistically offer real competition in the
                        Europe dominated market. However, who knows whether this will still be the case in ten or 15
                        years time? For those looking for an alternative investable fine wine that has low pricing and
                        good ageing potential, Restless River is most definitely a wine to watch.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RestlessRiver",
    data() {
        return {
            select: {report: 'Restless River', src: '/wine-guide/south-africa/constantia/restless-river'},
            items: [
                {report: 'Restless River', src: '/wine-guide/south-africa/constantia/restless-river'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Restless River | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the unique terroir of the Constantia wine region with Restless River, a premium wine producer known for their exceptional, handcrafted wines.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
